import { CREATE_ASSESSMENT, RECEIVE_ASSESSMENT, RECEIVE_ASSESSMENT_AGREEMENT, REQUEST_ASSESSMENT } from '../actions'

export default (
    state = {
        agreementFetchSuccessful: null,
        fetchSuccessful: null,
        isCreating: null,
        isFetching: false,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case CREATE_ASSESSMENT:
            return { ...state, isCreating: true }

        case REQUEST_ASSESSMENT:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_ASSESSMENT:
            return { ...state, isFetching: false, ...data }

        case RECEIVE_ASSESSMENT_AGREEMENT: {
            return { ...state, ...data }
        }

        default:
            return state
    }
}
